import { render, staticRenderFns } from "./ClassRoomCard.vue?vue&type=template&id=66f0c256&scoped=true&"
import script from "./ClassRoomCard.vue?vue&type=script&lang=js&"
export * from "./ClassRoomCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f0c256",
  null
  
)

export default component.exports